import axios from 'axios';
import { getBaseUrl } from '../core';

export function getUserData(userId) {
    return axios.get(getBaseUrl(`users/${userId}`));
}
